import React, { useState } from "react";
import EditSupplier from "../../../../../entities/DashboardPage/AccountingModule/Supplier/EditSupplier";
import AuthService from "../../../../../api/AuthService";
import { useLocation, useNavigate } from "react-router-dom";

import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../context/AlertContext";

const EditSupplierPage = () => {
  const [loading, setLoading] = useState(false);
  const [oneSupplierDetails, setOneSupplierDetails] = useState([])
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const { item } = state || {};
  const navigate = useNavigate();

  const handleEditSupplier = async (data, id) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.updateSupplier(data, id);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/supplier")
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
      showAlert(error, "error");
    }
  };

  const getOneSupplierDetails = async (id) => {
    try {
      const result = await AuthService.handleGetSupplier(id);
      if (result?.success === true) {
        setOneSupplierDetails(result?.data)
      }
    } catch (error) {
      showAlert(error, "error");
    }

  }
  return (
    <EditSupplier handleEditSupplier={handleEditSupplier} loading={loading} oneSupplierDetails={oneSupplierDetails} item={item} getOneSupplierDetails={getOneSupplierDetails} />
  )
}

export default EditSupplierPage;
